import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from '../store';
import { getInfraestructuresByLocation } from '@/services/measurement';

// Estado inicial de `kpis`
const initialState = {
  infrastructure: [],
  selectedInfraTypes: [] as any[],
};

const dashboardSlice = createSlice({
  name: 'kpi',
  initialState,
  reducers: {
    setInfrastructure(state: any, action: PayloadAction<any>) {
      state.infrastructure = action.payload;
    },
    setSelectedInfrastructureTypes(state: any, action: PayloadAction<any>) {
      state.selectedInfraTypes = action.payload;
    },
  },
});

export const { setInfrastructure, setSelectedInfrastructureTypes } =
  dashboardSlice.actions;
export default dashboardSlice.reducer;

// Thunk para obtener los infraestructuras por locacion
// mode: opcional, si se pasa DASHBOARD_MODE.INFILTRATION_FLOW filtra assets para I&I mode
export const getInfrastructureByLocationAction =
  (selectedLocation: string, mode?: string) => async (dispatch: AppDispatch) => {
    const infrasResult = await getInfraestructuresByLocation(selectedLocation, mode || '');
    if (infrasResult) dispatch(setInfrastructure(infrasResult));
  };
